export default __webpack_public_path__ + "709ae57a7e6a34a59a360f124ef769b8.svg";